import PropTypes from 'prop-types';
import React from 'react';
import './font/css/fontello-embedded.css';

const Icon = (props) => {
  let icon = props.icon;

  return (
    <span {... props} className={'icon icon-' + icon} />
  );

};

Icon.propTypes = {
  icon: PropTypes.string.isRequired
};

export default Icon;



// WEBPACK FOOTER //
// ./src/component/atoms/Icon/index.js